// extracted by mini-css-extract-plugin
export default {"selectable-body-row--selected":"selectable-body-row_selectable-body-row--selected__dUo1J","selectable-body-row__checkbox":"selectable-body-row_selectable-body-row__checkbox__ep-iv"};